import React from 'react'

import { Box } from 'widgets/Box'
import { Icon } from 'widgets/Icon'
import { Text } from 'widgets/Text'

import { ThemeColor } from 'utils/themes/types'

export const NoContent = ({
  message = 'There is no content yet. Try again later.',
  textColor,
  iconBackgroundColor = 'grey',
  iconColor = 'text',
}: {
  message?: string
  textColor?: ThemeColor
  iconBackgroundColor?: ThemeColor
  iconColor?: ThemeColor
}) => (
  <Box flex={1} justifyContent='center' align='center'>
    <Box
      width={50}
      height={50}
      borderRadius='xl'
      backgroundColor={iconBackgroundColor}
      justifyContent='center'
      align='center'
    >
      <Icon color={iconColor} name='stopwatch' size={32} />
    </Box>
    <Box padding={{ vertical: 'sm', horizontal: 'md' }}>
      {message && (
        <Text align='center' color={textColor}>
          {message}
        </Text>
      )}
    </Box>
  </Box>
)
